import React, { useEffect, useState } from 'react';
import { GlobalNav } from '@nexus/fff-global-nav';

import SubMenu from './SubMenu';
import { checkPermissions } from '../../services/auth';
import './Layout.css';

const Layout = React.memo(({ children }) => {
  const [hasPermissions, setHasPermissions] = useState(false);
  useEffect(() => {
    checkPermissions().then(() => setHasPermissions(true));
  }, []);

  return (
    <div className="layout">
      {hasPermissions && (
        <>
          <MemoizedGlobalNav />
          <SubMenu />
          {children}
        </>
      )}
    </div>
  );
});

Layout.defaultProps = {
};

Layout.propTypes = {
};

export default Layout;

const MemoizedGlobalNav = React.memo(() => <GlobalNav env={process.env.REACT_APP_ENVIRONMENT} />);
